import React, { useEffect, useRef } from 'react';

import {
    Text,
    Container,
    Row,
    Col,
    className,
    Heading,
} from 'aplazame-design-system';

import style from './style.module.scss';
import colorStyle from 'aplazame-design-system/src/scss/color.module.scss';

export default function ViterbitJobsSection({ title, titleTag }) {
    const offersRef = useRef();

    useEffect(() => {
        if (typeof window === 'undefined' || !offersRef || !offersRef.current) {
            return;
        }

        let script = window.document.createElement(`script`);
        script.src =
            'https://app.viterbit.com/build/js/vbtheme/pages/company/jobswidget/jobs_widget-278f6813eb.js';
        script.onload = () => {
            setTimeout(() => {
                let links = offersRef.current.querySelectorAll('a[href]');
                [...links].forEach((link) => {
                    link.setAttribute('target', '_blank');
                });
            }, 1000);
        };
        window.document.head.appendChild(script);
    }, [offersRef]);

    return (
        <section {...className(`${colorStyle['bg--tertiary']}`)}>
            <Container pt={{ xs: 7, lg: 10 }} pb={{ xs: 5, lg: 10 }}>
                <Row>
                    <Col>
                        <Heading
                            tag={titleTag}
                            className={style.heading}
                            mb={{ xs: 4, lg: 5 }}
                            data-sal="slide-up"
                            data-sal-easing="ease-out-quart"
                        >
                            {title}
                        </Heading>
                    </Col>
                    <Col>
                        <div
                            ref={offersRef}
                            data-sal="slide-up"
                            data-sal-easing="ease-out-quart"
                            className={style.widget}
                            id="vb-jobs"
                            data-url="https://app.viterbit.com/jobs-widget/COmlbYioMF9/open-url/"
                        />
                    </Col>
                </Row>
            </Container>
        </section>
    );
}
